import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useField } from 'react-final-form';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import CommonTextarea from '../../../../../components/common-textarea/CommonTextarea';
import WithError from '../../../../../components/with-error/WithError';

import { REQUEST_TYPE } from '../../../../constants/contact';
import SupportFields from './components/SupportFields';
import BugReportFields from './components/BugReportFields';

import scss from '../Steps.module.scss';

function StepRequestDescription() {
  const { t } = useTranslation('contact');

  const { input: requestTypeInput } = useField('requestType');

  return (
    <div className={scss.stepFormWrapper}>
      {requestTypeInput.value === REQUEST_TYPE.BUG_REPORT && <BugReportFields />}
      {requestTypeInput.value === REQUEST_TYPE.SUPPORT && <SupportFields />}

      <Field name='description'>
        {({ meta, input }) => (
          <WithLabel label={t('description')} variant={LABEL_STYLES.COLUMN} isBold isTwoDots isRequired>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                rows='4'
                enableVoiceInput
              />
            </WithError>
          </WithLabel>
        )}
      </Field>
    </div>
  );
}

export default StepRequestDescription;
